/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { HolidayConflictViewModel } from "../types/HolidayConflictViewModel.ts";

export const holidayConflictViewModelSchema = z.object({
  date: z.optional(z.string().datetime()),
}) as unknown as ToZod<HolidayConflictViewModel>;
